// import { createStore, applyMiddleware, compose } from "redux";
// import { thunk } from "redux-thunk";

// import reducers from "../reducers";

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// export default createStore(reducers, composeEnhancers(applyMiddleware(thunk)));


import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import reducers from "../reducers";

const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(thunk),
    devTools: process.env.NODE_ENV !== "production",
    preloadedState: {}, // Optional: Add your initial state here if needed

});

export default store;